const DashboardIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.91664 7.24721C3.29498 7.5 3.82166 7.5 4.875 7.5C5.92835 7.5 6.45502 7.5 6.83336 7.24721C6.99715 7.13777 7.13777 6.99714 7.24721 6.83336C7.5 6.45502 7.5 5.92834 7.5 4.875C7.5 3.82166 7.5 3.29498 7.24721 2.91664C7.13777 2.75286 6.99715 2.61223 6.83336 2.50279C6.45502 2.25 5.92835 2.25 4.875 2.25C3.82166 2.25 3.29498 2.25 2.91664 2.50279C2.75286 2.61223 2.61223 2.75286 2.5028 2.91664C2.25 3.29498 2.25 3.82166 2.25 4.875C2.25 5.92834 2.25 6.45502 2.5028 6.83336C2.61223 6.99714 2.75286 7.13777 2.91664 7.24721Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M11.1666 7.24721C11.545 7.5 12.0716 7.5 13.125 7.5C14.1783 7.5 14.705 7.5 15.0833 7.24721C15.2471 7.13777 15.3878 6.99714 15.4972 6.83336C15.75 6.45502 15.75 5.92834 15.75 4.875C15.75 3.82166 15.75 3.29498 15.4972 2.91664C15.3878 2.75286 15.2471 2.61223 15.0833 2.50279C14.705 2.25 14.1783 2.25 13.125 2.25C12.0716 2.25 11.545 2.25 11.1666 2.50279C11.0029 2.61223 10.8622 2.75286 10.7527 2.91664C10.5 3.29498 10.5 3.82166 10.5 4.875C10.5 5.92834 10.5 6.45502 10.7527 6.83336C10.8622 6.99714 11.0029 7.13777 11.1666 7.24721Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M2.91664 15.4972C3.29498 15.75 3.82166 15.75 4.875 15.75C5.92835 15.75 6.45502 15.75 6.83336 15.4972C6.99715 15.3878 7.13777 15.2471 7.24721 15.0833C7.5 14.705 7.5 14.1784 7.5 13.125C7.5 12.0716 7.5 11.545 7.24721 11.1667C7.13777 11.0029 6.99715 10.8623 6.83336 10.7528C6.45502 10.5 5.92835 10.5 4.875 10.5C3.82166 10.5 3.29498 10.5 2.91664 10.7528C2.75286 10.8623 2.61223 11.0029 2.5028 11.1667C2.25 11.545 2.25 12.0716 2.25 13.125C2.25 14.1784 2.25 14.705 2.5028 15.0833C2.61223 15.2471 2.75286 15.3878 2.91664 15.4972Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M11.1666 15.4972C11.545 15.75 12.0716 15.75 13.125 15.75C14.1783 15.75 14.705 15.75 15.0833 15.4972C15.2471 15.3878 15.3878 15.2471 15.4972 15.0833C15.75 14.705 15.75 14.1784 15.75 13.125C15.75 12.0716 15.75 11.545 15.4972 11.1667C15.3878 11.0029 15.2471 10.8623 15.0833 10.7528C14.705 10.5 14.1783 10.5 13.125 10.5C12.0716 10.5 11.545 10.5 11.1666 10.7528C11.0029 10.8623 10.8622 11.0029 10.7527 11.1667C10.5 11.545 10.5 12.0716 10.5 13.125C10.5 14.1784 10.5 14.705 10.7527 15.0833C10.8622 15.2471 11.0029 15.3878 11.1666 15.4972Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default DashboardIcon;
